<template>
  <v-container class="container-card">
    <v-card>
      <Tabela />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Tabela from "@/components/parametros/tipoMetaPagamento/Tabela";

export default {
  name: "TipoMetaPagamento",

  components: {
    Tabela
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Tipo Meta Pagamento");
  }
};
</script>
